import styled, { css } from 'styled-components';
import { Tooltip } from '@twigeducation/ts-fe-components';

const ButtonSize = '2.3rem';

export const OptionsContainer = styled.div`
    position: relative;
    display: inline-block;
    vertical-align: top;
    max-height: ${ButtonSize};

    &::after {
        content: '';
        position: absolute;
        top: 79%;
        right: 3px;
        transform: scale(1);
        width: 6px;
        height: 6px;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: ${({ active }) =>
            active
                ? `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='6' fill='none' viewBox='0 0 6 6'><path fill='%23FFFFFF' fill-rule='evenodd' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' d='M5.274 5.4H1.126A.126.126 0 0 1 1 5.274L5.274 1c.07 0 .126.056.126.126v4.148c0 .07-.056.126-.126.126Z' clip-rule='evenodd'/></svg>")`
                : `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='6' fill='none' viewBox='0 0 6 6'><path fill='%23343A72' fill-rule='evenodd' stroke='%23343A72' stroke-linecap='round' stroke-linejoin='round' d='M5.274 5.4H1.126A.126.126 0 0 1 1 5.274L5.274 1c.07 0 .126.056.126.126v4.148c0 .07-.056.126-.126.126Z' clip-rule='evenodd'/></svg>")`};
    }
`;

export const StyledTooltip = styled(Tooltip)`
    max-height: 2.3rem;
    height: 100%;
`;

export const OptionsList = styled.ol`
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    max-width: 310px;
    padding: 8px;
    gap: 8px;
    z-index: 100;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #343a72;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);

    &.stroke-width {
        grid-template-columns: repeat(6, 1fr);
    }

    @media (max-width: 640px) {
        grid-template-columns: repeat(3, 1fr);

        &.stroke-width {
            grid-template-columns: repeat(3, 1fr);
        }
    }
`;

export const OptionItem = styled.li`
    list-style-type: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${ButtonSize};
    height: ${ButtonSize};
    margin: 0;

    &:hover {
        transform: scale(1.1);
        z-index: 5;
        border-radius: 5px;
        background: #eaebf0;
    }
`;

export const OptionText = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    clip-path: inset(50%);
    border: 0;
`;

export const OptionIcon = styled.span`
    position: relative;
    display: inline-block;
    margin: 0 auto;

    img {
        display: block;
        width: 1.5rem;
        height: 1.5rem;
    }
`;

export const OptionButton = styled.button`
    width: ${ButtonSize};
    height: ${ButtonSize};
    background: ${({ active }) => (active ? '#128383' : '#fff')};
    position: relative;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: transparent;

    &:hover {
        cursor: pointer;
        background: ${({ active }) => (active ? '#128383' : '#eaebf0')};
    }

    &:focus-visible {
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px #000, 0 0 0px 5px #fff;
        outline: 2px solid transparent;
    }
    img {
        width: 20px;
        height: 20px;
    }

    &:focus:not(:focus-visible) {
        outline: none;
        box-shadow: none;
    }

    &[aria-label*='color'][style*='background-color: rgb(255, 255, 255)'] {
        border: 1px solid #757575 !important;
    }

    &.option-item-button:not([aria-label*='color']) {
        &:hover {
            background: #eaebf0 !important;
        }
    }
    ${({ withOptions, active }) =>
        withOptions &&
        css`
            &:hover {
                background: ${active ? '#128383' : '#eaebf0'};
            }
            &:active {
                background: ${active ? '#128383' : '#eaebf0'};
            }
            img {
                filter: ${active ? 'brightness(0) invert(1)' : '#343A72'};
            }
        `}
`;
